import { BimIcon, DocumentationIcon } from './ServicesIcons';
import HomeSectionAccordion from '../HomeSectionAccordion/HomeSectionAccordion';
import './style.css';

const Services = () => {
  return (
    <section className="section" id="services">
      <div className="container">
        <div className="services__frame">
          <HomeSectionAccordion
            id="services"
            title="Услуги"
            collapsedSummary="2D-документация и BIM-модели по данным лазерного сканирования."
          >
            <div className="services">
            <article className="service-item">
              <div className="service-item__icon-set">
                <div className="service-item__icon">
                  <DocumentationIcon />
                </div>
              </div>

              <h2 className="title-2">2D-документация</h2>

              <p className="service-item__description">
                Разрабатываем полный комплект чертежей существующего здания по данным лазерного
                сканирования для проектирования, реконструкции и анализа.
              </p>

              <div className="service-item__body">
                <p className="service-item__label">В состав документации входят:</p>

                <ul className="service-item__list">
                  <li>Поэтажные планы</li>
                  <li>Разрезы</li>
                  <li>Фасады</li>
                  <li>План кровли</li>
                  <li>Планы расстановки оборудования</li>
                  <li>Генеральный план участка</li>
                  <li>Дополнительные планы и схемы в зависимости от задач проекта</li>
                </ul>
              </div>

              <p className="service-item__note">
                Документация выполняется с соблюдением геометрической точности и проектных
                стандартов.
              </p>
            </article>

            <article className="service-item">
              <div className="service-item__icon-set">
                <div className="service-item__icon">
                  <BimIcon />
                </div>
              </div>

              <h2 className="title-2">BIM-моделирование</h2>

              <p className="service-item__description">
                Создаём информационные модели зданий по данным лазерного сканирования, готовые для
                проектирования, реконструкции и согласования инженерных решений.
              </p>

              <div className="service-item__body">
                <p className="service-item__label">Возможный уровень проработки модели:</p>

                <ul className="service-item__list">
                  <li>LOD 200 - укрупненная геометрия и основные габариты</li>
                  <li>LOD 300 - точная модель для проектных задач</li>
                  <li>LOD 350 - детальная проработка стыков элементов</li>
                </ul>
              </div>

              <p className="service-item__note">
                Модели формируются в BIM-среде и передаются в согласованных форматах, включая IFC.
              </p>
            </article>
            </div>
          </HomeSectionAccordion>
        </div>
      </div>
    </section>
  );
};

export default Services;
